export default __webpack_public_path__ + "static/media/metamask-logo.9fc5d2b4.svg";